import * as React from 'react';

import { useApplicationContext } from '@/app/shared/context/ApplicationContext';

import { EarlyAccessPaywallProvider as Provider } from '@/packages/EarlyAccessPaywall';
import { ESource } from '@/packages/EarlyAccessPaywall/shared/types/context';
import { useUserIsAuthenticatedSelector } from '@/packages/redux-state/store/slices/user';

import { fetchEarlyAccessPaywallMicrofrontend } from '../../services/fetchEarlyAccessPaywallMicrofrontend';

export const EarlyAccessPaywallProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => fetchEarlyAccessPaywallMicrofrontend(context), [context]);
  const isAuthenticated = useUserIsAuthenticatedSelector();

  const params = {
    isAuthenticated,
    source: ESource.Listing,
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
